import React, { useState, useEffect } from "react";
//component
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { brandCollection } from "../../../components/firebase/DataProvider";
import { useDocumentDataOnce } from "react-firebase-hooks/firestore";
//material component
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
//style
import useStyles from "./style/brandPolulerStyle";
import { useHistory } from "react-router-dom";
import { useMediaQuery, useTheme } from "@material-ui/core";
//slider
import ScrollContainer from "react-indiana-drag-scroll";

function Item({ id, key, load }) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const miniScreen = useMediaQuery(theme.breakpoints.down("600"));
  const [data] = useDocumentDataOnce(brandCollection.doc(id), {
    idField: "id",
  });

  // seceleton
  const [sece, setSece] = useState();
  setTimeout(() => {
    setSece(data);
  }, 1000);

  return (
    <div
      className={classes.wrapper}
      onClick={() =>
        history.push(`/kategori/brand/${data.nama}/${data.id}`, {
          data: data,
        })
      }
      key={key}
    >
      <Card className={classes.card}>
        {!sece || load ? (
          <div>
            <Skeleton
              variant="rect"
              style={{
                height: miniScreen ? 80 : 80,
                width: miniScreen ? 80 : 80,
              }}
            />
          </div>
        ) : (
          <CardActionArea>
            <div className={classes.wrapImg}>
              <img
                src={data?.icon}
                className={classes.medium}
                alt={data?.nama}
              />
            </div>
          </CardActionArea>
        )}
      </Card>
    </div>
  );
}

function BrandPopuler() {
  const classes = useStyles();

  const [items, setItems] = useState([]);

  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getItems() {
      setIsLoading(true);
      try {
        const getPopuler = firefunctions.httpsCallable("getPopular");

        const response = await getPopuler({ find_by: "brand" });

        setItems(response.data.popular_items);
      } catch (e) {
        console.log(e.message);
      }
      setIsLoading(false);
    }

    getItems();
  }, []);

  return (
    <Paper elevation={0} className={classes.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ marginTop: 10, marginBottom: 15, marginLeft: -10 }}>
          <Typography
            style={{
              fontSize: "13px",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            Brand Populer
          </Typography>
        </div>
        <div>
          <Button
            size="small"
            endIcon={<ArrowRightIcon />}
            onClick={() => history.push("/kategori")}
          >
            <Typography style={{ fontSize: "11px" }}>Lihat semua</Typography>
          </Button>
        </div>
      </div>
      <div className={classes.wrapKategori}>
        {isLoading ? (
          <div>
            <Skeleton
              variant="rect"
              style={{
                height: 80,
                width: "100%",
              }}
            />
          </div>
        ) : (
          <ScrollContainer className={classes.wrapScroll}>
            {items.map((item, index) => {
              return <Item id={item.brand_id} key={index} load={isLoading} />;
            })}
          </ScrollContainer>
        )}
      </div>
    </Paper>
  );
}

export default BrandPopuler;
